// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"peru_Tooltip__WyxxT","Indicador":"peru_Indicador__iWxH5","FadeIn":"peru_FadeIn__3icT3","fadeIn":"peru_fadeIn__1MGsO"};